/*
 * Created By sswaminathan
 * Created on Sun Sep 12 2021
 * Created on TenantSearch.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */
import { useEffect, useRef, useState, useCallback } from 'react'
import { Input, Body, Button } from '@panwds/react-ui-legacy'
import { RemoveIcon, SearchIcon } from '@panwds/icons'
import styled from 'styled-components'
import { LABEL_NO_RESULTS, LABEL_SEARCH_RESULTS } from '../../constants/LabelConstants'
import { ARRAY } from '../../../common/utils/Utils'

export const TEXTBOX = styled.div`
  height: 42px;

  & > span {
    background-color: rgb(34, 42, 51) !important;
    border-radius: 2px !important;
    font-size: 14px;
    line-height: 20px;
    // opacity: 0.2 !important;
    //color:#222A33;
    color: #707D8B;
    border: 0 #575757 !important;
  }

  & > span > input {
    color: #707D8B;
    width: 291.81px;
    height: 37.13px;
    left: 10px;
    top: 67.97px;
  }

  & > div {
    z-index: 10;
    position: absolute;
    width: 100%;
    background: rgb(34, 42, 51)
  }

  & > div > div > span {
    cursor: pointer;
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    /* identical to box height, or 143% */
    display: flex;
    align-items: center;
    //background-color: #313D4A;;
    width: 100%;
    /* -moz-border-radius: 2vw;
    -webkit-border-radius: 2vw;
    border-radius: 2vw;  */

    :hover {
      background-color: #475566;
    }
  }

  input.text-box::placeholder {
    color: #707D8B;
  }

  textarea:focus, input:focus {
    color: #b2bac4;
  }
`

const LISTITEM = styled.div`
  cursor: pointer;

  :hover {
    background-color: #475566;
  }
`

const SUBTENANT = styled(Body)`
  text-overflow: ellipsis;
  overflow: hidden;
  color: #85C8FF !important;
`

const TenantSearch = ({
  onTenantsSearch,
  treeData,
}) => {
  const [display, setDisplay] = useState(false)
  const [suggestions, setSuggestions] = useState([])
  const [searchInput, setSearchInput] = useState('')
  const wrapperRef = useRef(null)

  const searchTenant = useCallback((tenant, array, parent) => {
    if (tenant?.display_name?.toLowerCase().includes(searchInput?.toLowerCase()) || String(tenant?.id).startsWith(searchInput)) {
      if (tenant?.id !== '_superRoot') {
        array?.push({
          tenant,
          parent,
        })
      }
    }
    if (ARRAY.hasArray(tenant?.children)) {
      for (const child of tenant.children) {
        searchTenant(child, array, tenant)
      }
    }
    return array
  }, [searchInput])

  //Debouncing logic used to identify 300ms key press.
  useEffect(() => {
    setSuggestions(() => {
      return !searchInput?.trim().length ? [] : searchTenant(treeData[0], [])
    })
  }, [searchInput, onTenantsSearch, treeData, searchTenant])

  useEffect(() => {
    if (suggestions.length) {
      setDisplay(true)
    }
    else if (searchInput && !suggestions.length) {
      setDisplay(true)
    }
    else {
      setDisplay(false)
    }
  }, [searchInput, suggestions])

  // Search Validation Logic used
  const updateSelection = (value, id) => {
    setSearchInput('')
    setDisplay(false)
    onTenantsSearch(id)
  }
  const searchInPutHandler = (event) => {
    setSearchInput(event?.target?.value)
  }

  const bolderize = (text) => {
    if (!text) {
      return null
    }
    const foundIdx = text.toLowerCase().indexOf(searchInput.trim().toLowerCase())
    if (foundIdx < 0) {
      return <span>{text}</span>
    }
    const toIdx = foundIdx + searchInput.length
    return <span>{text.slice(0, foundIdx)}<strong>{
      text.slice(foundIdx, toIdx)
    }</strong>{text.slice(toIdx)}</span>
  }

  return (
    <>
      <TEXTBOX ref={wrapperRef} className={`tw-pt-2 tw-pr-4 ${display ? 'tw-bg-blue-steel-900' : ''}`}>
        <Input
          addClassName="tw-pl-2 tw-ml-2 tw-mb-2 tw-pr-3 tw-mr-3 tw-w-full"
          prefix={<SearchIcon size='sm' className='cm-text-gray-300' />}
          suffix={searchInput ? <Button
            addClassName='hover:tw-bg-blue-steel-100 hover:tw-opacity-60'
            aria-label="clear"
            appearance="tertiary-clear"
            onClick={() => setSearchInput('')}
            size='sm'
            icon={<RemoveIcon size='sm' className='cm-text-gray-300' />}
          /> : null
          }
          placeholder="Search Tenant"
          value={searchInput}
          onChange={searchInPutHandler}
        />
      </TEXTBOX>
      {display && (
        <div className="tw-bg-blue-steel-900 tw-flex-none tw-overflow-y-scroll tw-overflow-x-hidden" style={{ height: 'calc(100% - 42px)' }}>
          <Body addClassName="tw-p-2 tw-text-white" size="lg">{LABEL_SEARCH_RESULTS}</Body>
          {suggestions.length ? suggestions.map(({ tenant, parent }, index) => {
            return (
              <div key={index} className="tw-p-2">
                <LISTITEM onClick={() => updateSelection(tenant.display_name, tenant.id)}>
                  {parent && <Body size="lg" addClassName="tw-text-white" data-tsg-id={parent.id}>{bolderize(parent.display_name)}</Body>}
                  <div tabIndex="0" data-tsg-id={tenant.id}>
                    <SUBTENANT size="lg">
                      {bolderize(tenant.display_name)}
                    </SUBTENANT>
                  </div>
                </LISTITEM>
              </div>
            )
          }) : (
            <div className="tw-p-2">
              {LABEL_NO_RESULTS}
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default TenantSearch
